const useStyles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    borderRadius: '4px',
    border: '1px solid #E0E0E0',
    background: '#FFF',
    cursor: 'pointer',
    flex: '1 0 0',
    padding: '12px 8px',
    position: 'relative',
    justifyContent: 'space-between',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    gap: '8px',
  },
  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
  },
  title: {
    fontSize: '14px',
    fontWeight: 700,
    color: '#252525',
    textTransform: 'uppercase',
  },
  subTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080',
  },
});
export default useStyles;
